import * as m from "./../../dist/es2015/hierarchy.js";
export const am5hierarchy = m;